module.exports = __webpack_public_path__ + "static/media/payment-tooltip.6fe598b9.png";